"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollToFirstInvalidControl = void 0;
var _react = require("react");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @typedef { import('react-hook-form').UseFormReturn } FormContext
 */
/**
 * 
 * @param {} errors 
 * @returns 
 */
var getInvalidControlPaths = function getInvalidControlPaths(errors) {
  return Object.entries(errors).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    if (value !== null && value !== void 0 && value.ref) {
      return [].concat(_toConsumableArray(acc), [value.ref.name]);
    }
    var keys = getInvalidControlPaths(value);
    return [].concat(_toConsumableArray(acc), _toConsumableArray(keys));
  }, []);
};
var getInvalidControlByPath = function getInvalidControlByPath(errors, path) {
  var splitted = path.split('.');
  var invalidControl = splitted.reduce(function (acc, part) {
    return acc[part];
  }, errors);
  return invalidControl.ref;
};
var getTopOffset = function getTopOffset(control) {
  var labelOffset = 150;
  return control.getBoundingClientRect().top + window.scrollY - labelOffset;
};

/**
 * 
 * @param { FormContext } formContext 
 */
var useScrollToFirstInvalidControl = exports.useScrollToFirstInvalidControl = function useScrollToFirstInvalidControl(formContext) {
  var formState = formContext.formState;
  var scrollToFirstInvalidControl = (0, _react.useCallback)(function () {
    var errors = formState.errors;
    if (Object.keys(errors).length > 0) {
      var errorKeys = getInvalidControlPaths(errors !== null && errors !== void 0 ? errors : {});
      if (errorKeys.length > 0) {
        var firstInvalidControl = getInvalidControlByPath(errors, errorKeys[0]);
        if (firstInvalidControl) {
          firstInvalidControl.focus();
          window.scroll({
            top: getTopOffset(firstInvalidControl),
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    }
  }, [formState]);
  return {
    scrollToFirstInvalidControl: scrollToFirstInvalidControl
  };
};